var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiBatteryLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6138_8549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 7H3V13H2V7Z",
    fill: "#EB5757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5C1.83696 5 1.20107 5.26339 0.732233 5.73223C0.263392 6.20107 0 6.83696 0 7.5L0 12.5C0 13.163 0.263392 13.7989 0.732233 14.2678C1.20107 14.7366 1.83696 15 2.5 15H15C15.663 15 16.2989 14.7366 16.7678 14.2678C17.2366 13.7989 17.5 13.163 17.5 12.5V7.5C17.5 6.83696 17.2366 6.20107 16.7678 5.73223C16.2989 5.26339 15.663 5 15 5H2.5ZM15 6.25C15.3315 6.25 15.6495 6.3817 15.8839 6.61612C16.1183 6.85054 16.25 7.16848 16.25 7.5V12.5C16.25 12.8315 16.1183 13.1495 15.8839 13.3839C15.6495 13.6183 15.3315 13.75 15 13.75H2.5C2.16848 13.75 1.85054 13.6183 1.61612 13.3839C1.3817 13.1495 1.25 12.8315 1.25 12.5V7.5C1.25 7.16848 1.3817 6.85054 1.61612 6.61612C1.85054 6.3817 2.16848 6.25 2.5 6.25H15ZM20 10C20 10.4973 19.8025 10.9742 19.4508 11.3258C19.0992 11.6775 18.6223 11.875 18.125 11.875V8.125C18.6223 8.125 19.0992 8.32254 19.4508 8.67417C19.8025 9.02581 20 9.50272 20 10Z",
    fill: "#EB5757"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6138_8549"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiBatteryLow);
export default __webpack_public_path__ + "static/media/bi_battery-low.319cc7e2ae027fa3706d3cbec28509ce.svg";
export { ForwardRef as ReactComponent };